import type { SanityTable as SanityTableType } from '../../lib/sanity/types';

type SanityTableProps = {
  value: SanityTableType;
  firstRowIsHeader?: boolean;
};

export const SanityTable = ({ value, firstRowIsHeader = true }: SanityTableProps) => {
  const { rows } = value;

  if (!rows || rows.length === 0) return null;

  const hasHeader = firstRowIsHeader && rows.length > 1;
  const headerRow = hasHeader ? rows[0] : null;
  const bodyRows = hasHeader ? rows.slice(1) : rows;

  return (
    <div className="my-6 overflow-x-auto">
      <table className="w-full border-collapse border border-gray-200 font-body text-[16px] leading-[24px]">
        {headerRow && (
          <thead>
            <tr className="bg-gray-50">
              {headerRow.cells.map((cell, i) => (
                <th
                  key={i}
                  className="border border-gray-200 px-4 py-3 text-left font-semibold"
                >
                  {cell}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {bodyRows.map((row) => (
            <tr key={row._key}>
              {row.cells.map((cell, i) => (
                <td key={i} className="border border-gray-200 px-4 py-3">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
